import { CurrencyPipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { take, finalize, Subscription } from 'rxjs';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { AmpliacaoService } from 'src/app/modules/services/ampliacao/ampliacao.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import * as moment from 'moment';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
@Component({
  selector: 'app-form-ampliacao',
  templateUrl: './form-ampliacao.component.html',
  styleUrls: ['./form-ampliacao.component.scss']
})
export class FormAmpliacaoComponent {
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @ViewChild(FormGroupDirective) formDirective!: FormGroupDirective;
  form!: FormGroup;
  subsctiptions: Subscription[] = [];
  origensObra: any[] = [];
  tiposObra: any[] = [];
  municipios: any[] = [];
  contract: any;
  municipiosOrdenados = [...this.municipios];
  sentidos = [
    { id: 1, nome: 'Crescente' },
    { id: 2, nome: 'Decrescente' },
    { id: 3, nome: 'Ambos' },
    { id: 4, nome: 'Norte' },
    { id: 5, nome: 'Sul' },
  ];
  idServicoAmpliacao: string | null = '';
  contractId: string | null = '';
  /** Tabela */
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  readonly columnConfig = [
    { columnDef: 'codigo', header: 'Código', property: 'codigo' },
    { columnDef: 'tipoObra', header: 'Tipo de obra', property: 'tipoObra.nome' },
    { columnDef: 'kmInicial', header: 'KM Inicial', property: 'kmInicial' },
    { columnDef: 'kmFinal', header: 'KM Final', property: 'kmFinal' },
    { columnDef: 'kmExtensao', header: 'Extensão', property: 'kmExtensao' },
    { columnDef: 'prazoVigenteInicial', header: 'Prazo Vigente Inicial', property: 'prazoVigenteInicial', customTd: true },
    { columnDef: 'prazoVigenteFinal', header: 'Prazo Vigente Final', property: 'prazoVigenteFinal', customTd: true },
    { columnDef: 'statusParametro.descricao', header: 'Status', property: 'statusParametro.descricao', customTd: true },
    { columnDef: 'actions', header: '', custom: true }
  ];
  /** Ordenação */
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc' as 'asc' | 'desc'
  };

  /** Paginação */
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  /** Layout */
  screenWidth = window.innerWidth;
  constructor(
    private fb: FormBuilder,
    private ampliacaoService: AmpliacaoService,
    private router: Router,
    private pageStateService: PageStateService,
    private pageSizeService: PageSizeService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private userService: UserService,
    private contractService: ContractService,
  ) {
    this.form = this.fb.group({
      codigo: ['', Validators.required],
      idOrigemObra: [null, Validators.required],
      idTipoObra: [null],
      trechoHomogeneo: [null],
      descricaoServico: ['', Validators.required],
      anoConclusao: ['', Validators.required],
      idsMunicipios: [[]],
      rodovia: ['', Validators.required],
      sentido: [null],
      segmentoHomogeneo: [''],
      kmInicial: [null, Validators.required],
      kmFinal: [null, Validators.required],
      kmCampoInicial: [''],
      kmCampoFinal: [''],
      naturezaPrazo: ['', Validators.required],
      prazoInicial: [null, Validators.required],
      prazoFinal: [null, Validators.required],
      prazoVigenteInicial: [null, Validators.required],
      prazoVigenteFinal: [null, Validators.required],
      valorObra: [''],
      valorObraAtualizado: [''],
      detalhamentoOrigemObra: [''],
      latitudeInicial: [''],
      latitudeFinal: [''],
      longitudeInicial: [''],
      longitudeFinal: [''],
      prazoAnaliseFuncional: [null],
      prazoAnaliseExecutivo: [null],
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.contractId = params.get('id');
      this.idServicoAmpliacao = params.get('idServicoAmpliacao');
    });
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.restorePageState();
    this.getData(this.pageIndex);
    this.carregarOrigens();
    this.carregarTipos();
    this.carregarMunicipios();
    this.loadContract();
    if (this.idServicoAmpliacao) {
      this.getServicoAmpliacao(this.idServicoAmpliacao);
    } else {
      this.loadPrazoSugestao();
    }
      this.loadUserInfo();
  }

  carregarOrigens(nome?: string) {
    this.ampliacaoService.getOrigensObra(0, 50, nome).subscribe({
      next: (res: any) => (this.origensObra = res.content),
      error: err => console.error('Erro ao carregar origens', err)
    });
  }

  carregarTipos(nome?: string) {
    this.ampliacaoService.getTiposObra(0, 50, nome).subscribe({
      next: (res: any) => (this.tiposObra = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }

  carregarMunicipios(nome?: string) {
    this.ampliacaoService.getMunicipios(0, 900, nome).subscribe({
      next: (res: any) => {
        this.municipios = res.content;
        this.municipiosOrdenados = [...this.municipios];
      },
      error: err => console.error('Erro ao carregar municípios', err)
    });
  }

  loadContract(): void {
    if (!this.contractId) return;
    this.contractService.getContract(this.contractId)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => (this.contract = res),
        error: () => {}
      });
  }
  handleSubmit() {
    this.idServicoAmpliacao ? this.edit() : this.create();
  }
  create() {
    const form = { ...this.form.value };

    // Formata apenas os campos de data
    form.prazoInicial = form.prazoInicial ? moment(form.prazoInicial).format('YYYY-MM-DD') : null;
    form.prazoFinal = form.prazoFinal ? moment(form.prazoFinal).format('YYYY-MM-DD') : null;
    form.prazoVigenteInicial = form.prazoVigenteInicial ? moment(form.prazoVigenteInicial).format('YYYY-MM-DD') : null;
    form.prazoVigenteFinal = form.prazoVigenteFinal ? moment(form.prazoVigenteFinal).format('YYYY-MM-DD') : null;
    // Converte valores monetários para número com ponto decimal
    const parseCurrency = (value: string) => {
      if (!value) return 0;
      // remove pontos de milhar e troca vírgula por ponto
      return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    };
    form.latitudeInicial = parseFloat(this.form.get('latitudeInicial')?.value);
    form.latitudeFinal = parseFloat(this.form.get('latitudeFinal')?.value);
    form.longitudeInicial = parseFloat(this.form.get('longitudeInicial')?.value);
    form.longitudeFinal = parseFloat(this.form.get('longitudeFinal')?.value);
    form.valorObra = parseCurrency(form.valorObra);
    form.valorObraAtualizado = parseCurrency(form.valorObraAtualizado);
    this.loadingService.showLoading();
    this.ampliacaoService.create(form, this.contractId).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe(
      (response: any) => {
        this.getData();
        this.toastService.showSuccess(response.message);
        this.resetFormState();
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    );
  }
  edit() {
    const form = { ...this.form.value };
      const parseCurrency = (value: string) => {
        if (!value) return 0;
        // remove pontos de milhar e troca vírgula por ponto
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
      };

    // Verifica se os dados já estão no formato esperado para a API
    // A verificação é feita em um dos campos de data. Se já estiver formatado,
    // assume-se que os demais campos também estão.
    const isAlreadyFormatted = typeof form.prazoInicial === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(form.prazoInicial);

    if (!isAlreadyFormatted) {
      // Formata apenas os campos de data
      form.prazoInicial = form.prazoInicial ? moment(form.prazoInicial).format('YYYY-MM-DD') : null;
      form.prazoFinal = form.prazoFinal ? moment(form.prazoFinal).format('YYYY-MM-DD') : null;
      form.prazoVigenteInicial = form.prazoVigenteInicial ? moment(form.prazoVigenteInicial).format('YYYY-MM-DD') : null;
      form.prazoVigenteFinal = form.prazoVigenteFinal ? moment(form.prazoVigenteFinal).format('YYYY-MM-DD') : null;

      // Converte valores monetários para número com ponto decimal
      form.latitudeInicial = parseFloat(this.form.get('latitudeInicial')?.value);
      form.latitudeFinal = parseFloat(this.form.get('latitudeFinal')?.value);
      form.longitudeInicial = parseFloat(this.form.get('longitudeInicial')?.value);
      form.longitudeFinal = parseFloat(this.form.get('longitudeFinal')?.value);


    }
    if (typeof form.valorObra === 'string') {
      form.valorObra = parseCurrency(form.valorObra);
    }

   
    if (typeof form.valorObraAtualizado === 'string') {
      form.valorObraAtualizado = parseCurrency(form.valorObraAtualizado);
    }
    this.loadingService.showLoading();
    // Altera o serviço de 'servicosIniciais' para 'ampliacaoService'
    this.ampliacaoService.edit(form, this.contractId, this.idServicoAmpliacao).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe(
      (response: any) => {
        this.getData();
        this.toastService.showSuccess(response.message);
        this.resetFormState();
        // Removendo as linhas específicas de `selectedOption` e `searchControl`
        // pois não estavam presentes na sua função `create` original
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    );
  }
  /** Buscar dados da tabela */
  getData(pageIndex: number = 0): void {
    const { sortDirection, sortProperty } = this.sortState;

    this.ampliacaoService.getServicosAmpliacao(
      this.pageSize,
      pageIndex,
      sortDirection,
      sortProperty,
      this.contractId,
      ''
    ).subscribe((resp: any) => this.handleResponse(resp));
  }

  /** Tratar resposta da API */
  private handleResponse(resp: any): void {
    const { content, pageSize, totalPages, totalElements, pageNumber } = resp;

    this.dataSource.data = content ?? [];
    this.pageSize = pageSize ?? this.pageSize;
    this.totalPages = totalPages ?? 0;
    this.totalElements = totalElements ?? 0;
    this.pageIndex = pageNumber ?? 0;
  }

  /** Alterar ordenação */
  onSortChange(sortProperty: string): void {
    this.sortState.sortDirection =
      this.sortState.sortProperty === sortProperty
        ? (this.sortState.sortDirection === 'asc' ? 'desc' : 'asc')
        : 'asc';

    this.sortState.sortProperty = sortProperty;
    this.getData();
  }

  /** Evento de mudança de página */
  pageChangeEvent(event: PageEvent): void {
    const pageChanged = this.pageIndex !== event.pageIndex;
    const sizeChanged = this.pageSize !== event.pageSize;

    if (sizeChanged) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      this.getData(0);
      return;
    }

    if (pageChanged) {
      this.getData(event.pageIndex);
    }
  }

  /** Recuperar estado salvo da página */
  private restorePageState(): void {
    const savedPageIndex = this.pageStateService.getPageState(this.router.url);
    if (savedPageIndex) {
      this.pageIndex = savedPageIndex;
    }
  }
  back() {
    this.router.navigate([`contrato/${this.contractId}/detalhes`]);
  }

  resetFormState(): void {
    const initial = {
      codigo: '',
      idOrigemObra: null,
      idTipoObra: null,
      trechoHomogeneo: null,
      descricaoServico: '',
      anoConclusao: '',
      idsMunicipios: [], // <-- reset correto do mat-select multiple
      rodovia: '',
      sentido: null,
      segmentoHomogeneo: '',
      kmInicial: null,
      kmFinal: null,
      kmCampoInicial: '',
      kmCampoFinal: '',
      naturezaPrazo: '',
      prazoInicial: null,
      prazoFinal: null,
      prazoVigenteInicial: null,
      prazoVigenteFinal: null,
      valorObra: '',
      valorObraAtualizado: '',
      detalhamentoOrigemObra: '',
      latitudeInicial: '',
      latitudeFinal: '',
      longitudeInicial: '',
      longitudeFinal: '',
      prazoAnaliseFuncional: null,
      prazoAnaliseExecutivo: null,
    };

    // Recomendo usar o FormGroupDirective: reseta também o flag `submitted`
    if (this.formDirective) {
      this.formDirective.resetForm(initial);
      this.loadPrazoSugestao();
      return;
    }

    // Fallback caso não encontre o directive
    this.form.reset(initial);
    this.loadPrazoSugestao();
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.setErrors(null);
      control?.markAsPristine();
      control?.markAsUntouched();
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

  limitYear(event: any) {
    const input = event.target as HTMLInputElement;

    // Remove sinais negativos
    if (input.value.startsWith('-')) {
      input.value = input.value.replace('-', '');
    }

    // Limita a 4 dígitos
    if (input.value.length > 4) {
      input.value = input.value.slice(0, 4);
    }

  }
  formatarValor(event: Event, campo: any): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;

    // Remove tudo que não seja número
    valor = valor.replace(/\D/g, '');
    if (valor.length > 2) {
      // Insere vírgula para as duas casas decimais
      valor = valor.slice(0, -2) + ',' + valor.slice(-2);
    }
    // Adiciona pontos como separadores de milhar
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Atualiza o valor do campo e o FormControl
    input.value = valor;
    this.form.get(campo)?.setValue(valor);
  }

  reordenarMunicipios(): void {
    const selecionados = this.form.value.idsMunicipios;

    this.municipiosOrdenados = [
      ...this.municipios.filter(m => selecionados.includes(m.id)),   // selecionados primeiro
      ...this.municipios.filter(m => !selecionados.includes(m.id))  // os demais
    ];
  }

  openDeleteDialog(id: number): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Serviço?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.ampliacaoService.deleteServico(id, this.contractId).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (resp: any) => {
          this.openSnackBar('Serviço deletado com sucesso.', 'sucess');
          this.getData();
        }, error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }

  toEdit(id: any): void {
    this.idServicoAmpliacao = id;
    this.getServicoAmpliacao(id);
  }
  getServicoAmpliacao(idServicoAmpliacao: string) {
    this.ampliacaoService.getServicoAmpliacao(this.contractId, idServicoAmpliacao).subscribe({
      next: (res: any) => {
        this.patchValue(res);
      }, error: (err: any) => {
        this.openSnackBar(err.message, 'error')
      }
    });
  }
  patchValue(data: any) {
    this.form.patchValue({
      codigo: data.codigo,
      // Verifica se os objetos aninhados existem antes de acessar suas propriedades
      idOrigemObra: data.origemObra ? data.origemObra.id : null,
      idTipoObra: data.tipoObra ? data.tipoObra.id : null,
      descricaoServico: data.descricaoServico,
      anoConclusao: data.anoConclusao,
      // Verifica se a propriedade existe e é um array antes de usar map()
      idsMunicipios: data.municipios && Array.isArray(data.municipios) ? data.municipios.map((m: any) => m.id) : [],
      rodovia: data.rodovia,
      sentido: data.sentido,
      segmentoHomogeneo: data.segmentoHomogeneo,
      kmInicial: data.kmInicial,
      kmFinal: data.kmFinal,
      kmCampoInicial: data.kmCampoInicial,
      kmCampoFinal: data.kmCampoFinal,
      naturezaPrazo: data.naturezaPrazo,
      prazoInicial: data.prazoInicial,
      prazoFinal: data.prazoFinal,
      prazoVigenteInicial: data.prazoVigenteInicial,
      prazoVigenteFinal: data.prazoVigenteFinal,
      valorObra: data.valorObra,
      valorObraAtualizado: data.valorObraAtualizado,
      detalhamentoOrigemObra: data.detalhamentoOrigemObra,
      latitudeInicial: data.latitudeInicial,
      latitudeFinal: data.latitudeFinal,
      longitudeInicial: data.longitudeInicial,
      longitudeFinal: data.longitudeFinal,
      prazoAnaliseFuncional: data.prazoAnaliseFuncional ?? null,
      prazoAnaliseExecutivo: data.prazoAnaliseExecutivo ?? null,
    });
  }

  loadPrazoSugestao(): void {
    if (!this.contractId) return;
    this.contractService.getPrazoAnaliseProjeto(this.contractId)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.form.patchValue({
              prazoAnaliseFuncional: res.prazoAnaliseFuncional ?? null,
              prazoAnaliseExecutivo: res.prazoAnaliseExecutivo ?? null,
            });
          }
        },
        error: () => {}
      });
  }

    loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }
  checkFunctionality(functionality: any) {

    if (functionality.url === '/contratos') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
    preventNegativePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (isNaN(Number(pasted)) || Number(pasted) < 0) {
      event.preventDefault();
    }
  }

  blockNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '—') {
      event.preventDefault();
    }
  }
}
